module.exports = __webpack_public_path__ + "static/media/sk.b8b4cdd0.svg";